import { OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService, UserService } from '@base/shared/services';
import { get } from 'lodash';
var CompletedTeammateInvitationComponent = /** @class */ (function () {
    function CompletedTeammateInvitationComponent(modalService, activeModal, navigation, accountService) {
        this.modalService = modalService;
        this.activeModal = activeModal;
        this.navigation = navigation;
        this.accountService = accountService;
        this.data = JSON.parse(localStorage.getItem('eyrus-members-invited') || '[]') || [];
        this.type = 'project';
        this.title = '';
        this.created = false;
    }
    CompletedTeammateInvitationComponent.prototype.ngOnInit = function () {
    };
    CompletedTeammateInvitationComponent.prototype.confirm = function () {
        this.cleanData();
        this.activeModal.close(true);
    };
    CompletedTeammateInvitationComponent.prototype.close = function () {
        this.cleanData();
        this.activeModal.close(false);
    };
    Object.defineProperty(CompletedTeammateInvitationComponent.prototype, "getTitle", {
        get: function () {
            return this.type === 'contract' ? get(this.accountService, 'account.contract.company.companyName') : this.title;
        },
        enumerable: true,
        configurable: true
    });
    CompletedTeammateInvitationComponent.prototype.goToMembers = function () {
        this.confirm();
    };
    CompletedTeammateInvitationComponent.prototype.goToCreateContract = function () {
        this.cleanData();
        this.activeModal.close('create-contract');
    };
    CompletedTeammateInvitationComponent.prototype.goToDailyLogs = function () {
        this.cleanData();
        this.activeModal.close('daily-logs');
    };
    CompletedTeammateInvitationComponent.prototype.goToProjectSettings = function () {
        this.cleanData();
        this.activeModal.close('settings');
    };
    CompletedTeammateInvitationComponent.prototype.cleanData = function () {
        localStorage.removeItem('eyrus-members-invited');
        localStorage.removeItem('eyrus-item-created');
    };
    return CompletedTeammateInvitationComponent;
}());
export { CompletedTeammateInvitationComponent };
